export const SessionKeys = {
  RedirectFromMarketplace: 'redirected_from_marketplace',
};
